<template>

</template>

<script>
  export default {
    name: "earth2.vue",
    mounted: function () {
      window.location.href="https://cloudlark.pingxingyun.com:8180/enterAppli?appliId=887296596247576576&groupId=887297186440675328"
    },
  }

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/other/earth2.vue